var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.series && _vm.series.length > 0)?_c('div',[_c('ApexChart',{attrs:{"type":"pie","options":_vm.chartOptions,"series":_vm.series}})],1):_c('div',[_vm._v("Not Data available")])])}
var staticRenderFns = []

export { render, staticRenderFns }